import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/all-about-my-days', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/all-about-my-days', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/all-about-my-days/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = data => {
  return httpClient
    .put(`/api/all-about-my-days/${data.id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient
    .delete(`/api/all-about-my-days/${id}`)
    .then(response => Promise.resolve(response.data))
}

export const classRoom = (Options = {}) => {
  return httpClient
    .get('/api/all-about-my-days/class')
    .then(response => Promise.resolve(response.data))
    .catch(response => Promise.reject(response.data))
}

export const student = (Options = {}) => {
  return httpClient
    .get('/api/all-about-my-days/students', Options)
    .then(response => Promise.resolve(response.data))
    .catch(response => Promise.reject(response.data))
}

export const findData = (Options = {}) => {
  return httpClient
    .get('/api/all-about-my-days/find-datas', Options)
    .then(response => Promise.resolve(response.data))
    .catch(response => Promise.reject(response.data))
}
export const getSetting = (Options = {}) => {
  return httpClient
    .get('/api/all-about-my-days/check-setting', Options)
    .then(response => Promise.resolve(response.data))
    .catch(response => Promise.reject(response.data))
}
export const manualRelease = (Options = {}) => {
  return httpClient
    .get('/api/all-about-my-days/manual-releases', Options)
    .then(response => Promise.resolve(response.data))
    .catch(response => Promise.reject(response.data))
}

export default {
  get,
  find,
  store,
  update,
  destroy,
  classRoom,
  student,
  findData,
  getSetting,
  manualRelease
}
